import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { all_routes } from "../feature-module/router/all_routes";
import FacebookBlackIcon from "../icons/FacebookBlackIcon";
import TwitterBlackIcon from "../icons/TwitterBlackIcon";
import InstagramBlackIcon from "../icons/InstagramBlackIcon";
import LinkedinBlackIcon from "../icons/LinkedinBlackIcon";
import YoutubeBlackIcon from "../icons/YoutubeBlackIcon";
import { mainFooterMenuItems } from "../constants/mainMenu";
import MapIcon from "../icons/MapIcon";
import EnvlopeIcon from "../icons/EnvlopeIcon";
import PhoneIcon from "../icons/PhoneIcon";
import MobileIcon from "../icons/MobileIcon";

const Footer = () => {
  const routes = all_routes;
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Check if the current route contains "dashboard"
  const isChatbotRoute = location.pathname.includes("dashboard");

  return (
    <footer className="footer">
      {isChatbotRoute && (
        <div className="chatbotWrapper">
          <Link to={routes.chatbot}>
            <span className="box_1">
              <img src="/assets/img/chatbotIcon.svg" alt="chatbot" />
            </span>
            <p className="mb-0">Need Help ?</p>
          </Link>
        </div>
      )}

      <div className="container-fluid">
        {/* /Footer Join */}
        {/* Footer Top */}
        <div className="footer-top">
          <div className="row">
            <div className="col-lg-4">
              <div className="logoWrapper">
                <Link to={"/"}>
                  <img src="/assets/img/whiteLogo.svg" alt="logo" />
                </Link>
                <p className="mt-4 text-white">
                  TracNest – The Ultimate Real Estate Professional Hours
                  Tracker
                </p>
              </div>
            </div>
            <div className="col-md-8 col-lg-8">
              <div className="row">
                <div className="col-md-4">
                  <h4 className="text-white">Quick Links</h4>

                  {/* <ul className="d-flex flex-wrap gap-3 text-white">
                    <li><Link className="text-white" to={'/'}>Home</Link></li>
                    <li><Link className="text-white" to={'/about-us'}>About Us</Link></li>
                    <li><Link className="text-white" to={'/blog'}>Blog</Link></li>
                    <li><Link className="text-white" to={'/faq'}>FAQ</Link></li>
                    <li><Link className="text-white" to={'/contact-us'}>Contact</Link></li>
                  </ul> */}

                  <ul className="d-flex flex-column gap-3 text-white">
                    {mainFooterMenuItems.map((item, index) => (
                      <li key={index}>
                        <a
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer" // Security!
                          className="text-white"
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-4">
                  <h4 className="text-white">Contact</h4>
                  <div className="appBtns flex-column d-flex gap-3 text-white">
                    <Link
                      className="text-white"
                      target="_blank"
                      to={"https://maps.app.goo.gl/myqDgVc1uE8HeJkb9"}
                    >
                      <span className="me-2">
                        <MapIcon />
                      </span>
                      1234 Elm Street Springfield, IL 62704 USA
                    </Link>
                    <Link
                      className="text-white"
                      to={"mailto:support@tracnest.com"}
                    >
                      <span className="me-2">
                        <EnvlopeIcon />
                      </span>
                      support@tracnest.com
                    </Link>
                    <Link className="text-white" to={"tel:039434 1120"}>
                      <span className="me-2">
                        <MobileIcon />
                      </span>
                      925-308-3914
                    </Link>
                  </div>
                </div>
                <div className="col-md-4">
                  <h4 className="text-white">Social</h4>
                  <ul className="socialMenu d-flex gap-2">
                    <li>
                      <Link to={"/"}>
                        <FacebookBlackIcon />
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={"/"}>
                        <TwitterBlackIcon />
                      </Link>
                    </li> */}
                    <li>
                      <a
                        href="https://www.instagram.com/tracnestpro/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <InstagramBlackIcon />
                      </a>
                    </li>
                    <li>
                      <Link to={"/"}>
                        <LinkedinBlackIcon />
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/@SMEEDDev"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                      >
                        <YoutubeBlackIcon />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Footer Top */}
      </div>
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container-fluid">
          {/* Copyright */}
          <div className="copyright">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="copyright-text">
                  <p className="mb-0">
                    © {new Date().getFullYear()} Trac Nest. All rights
                    reserved.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                {/* Copyright Menu */}
                <div className="dropdown-blk">
                  <ul className="d-flex justify-content-end gap-2">
                    <li>
                      <Link
                        className="text-white"
                        target="_blank"
                        to={"https://tracnest.com/terms-conditions"}
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                    <li>|</li>
                    <li>
                      <Link
                        className="text-white"
                        target="_blank"
                        to={"https://tracnest.com/privacy-policy"}
                      >
                        Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* /Copyright Menu */}
              </div>
            </div>
          </div>
          {/* /Copyright */}
        </div>
      </div>
      {/* /Footer Bottom */}
    </footer>
  );
};

export default Footer;
